/**
 * first returns the first value defined by the argument type which can
 * either be any value or an array of the same value type. If the array is empty
 * it will return undefined.
 */
export function first<T>(value: T | T[]): T | undefined {
  return Array.isArray(value) ? value.at(0) : value;
}
